<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M4.36011 8.27992L6.88011 11.0799L11.6401 4.91992"
            stroke="currentColor"
            stroke-width="1.512"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.76 1H3.24C2.00288 1 1 2.00288 1 3.24V12.76C1 13.9972 2.00288 15 3.24 15H12.76C13.9972 15 15 13.9972 15 12.76V3.24C15 2.00288 13.9972 1 12.76 1Z"
            stroke="currentColor"
            stroke-width="1.512"
            stroke-miterlimit="3.99393"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
